import React from "react"
import CategoryModel from "sdk/CategoryModel"
import shop from "shop/shop"

export default class CategoryModelOrfix extends CategoryModel {
  isHidden = false
  
  constructor( data ) {
    super( data )
    this.update()
  }
  
  update() {
    if ( !shop.session ) {
      console.log( this.map_id )
      if ( this.map_id === "persArt" ) {
        this.isHidden = true
      }
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/theme/orfix-test/shop/CategoryModel.js